var map = {
	"./arvo-latin-400-normal.woff2": 90050,
	"./arvo-latin-700-normal.woff2": 30948,
	"./cabin-latin-400-normal.woff2": 30551,
	"./cabin-latin-700-normal.woff2": 8705,
	"./open-sans-latin-400-normal.woff2": 5390,
	"./open-sans-latin-600-normal.woff2": 29063,
	"./open-sans-latin-700-normal.woff2": 11854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44819;